import { registerComponent, debounce } from "helpers";

registerComponent(
  "trending-searches",
  class TrendingSearches extends HTMLElement {
    constructor() {
      super();

      this.nextButton = this.querySelector(".trending-searches__button--right");
      this.prevButton = this.querySelector(".trending-searches__button--left");
      this.slideWrapper = this.querySelector(
        ".trending-searches__content-wrapper"
      );
      this.slideContent = this.querySelector(".trending-searches__content");

      this.setupSlider();
      this.bindEvents();
    }

    setupSlider() {
      this.slideWrapperRect = this.slideWrapper.getBoundingClientRect();
      this.slideContentRect = this.slideContent.getBoundingClientRect();

      if (this.slideWrapper.clientWidth >= this.slideContent.clientWidth) {
        return;
      }

      if (this.slideContentRect.right > this.slideWrapperRect.right - 1) {
        this.showNextButton();
      }
      if (this.slideContentRect.left < this.slideWrapperRect.left - 1) {
        this.showPrevButton();
      }
    }

    bindEvents() {
      window.addEventListener(
        "resize",
        debounce((event) => {
          this.rebuildSlider(event);
        }, 300).bind(this)
      );

      this.nextButton.addEventListener("click", this.scrollLeft.bind(this));
      this.prevButton.addEventListener("click", this.scrollRight.bind(this));

      this.slideWrapper.addEventListener("scroll", () => {
        this.showNextButton();
        this.showPrevButton();
      });
      this.slideWrapper.addEventListener("scrollend", () => {
        this.exposeButtons();
      });
    }

    rebuildSlider() {
      this.removeNextButton();
      this.removePrevButton();

      this.setupSlider();
    }

    exposeButtons() {
      this.slideWrapperRect = this.slideWrapper.getBoundingClientRect();
      this.slideContentRect = this.slideContent.getBoundingClientRect();

      if (this.slideContentRect.right - 1 < this.slideWrapperRect.right) {
        this.removeNextButton();
      }
      if (this.slideContentRect.left + 1 > this.slideWrapperRect.left) {
        this.removePrevButton();
      }
    }

    showNextButton() {
      this.slideContent.classList.add(
        "trending-searches__content--aligned-left"
      );
    }

    showPrevButton() {
      this.slideContent.classList.add(
        "trending-searches__content--aligned-right"
      );
    }

    removeNextButton() {
      this.slideContent.classList.remove(
        "trending-searches__content--aligned-left"
      );
    }

    removePrevButton() {
      this.slideContent.classList.remove(
        "trending-searches__content--aligned-right"
      );
    }

    scrollLeft() {
      this.slideWrapper.scrollLeft += this.slideWrapper.clientWidth;
    }

    scrollRight() {
      this.slideWrapper.scrollLeft -= this.slideWrapper.clientWidth;
    }
  }
);
